<template>
  <v-dialog
    v-model="modalJustificarAsistencia.status"
    persistent
    max-width="750"
  >
    <v-card>
      <v-card-title primary-title class="text-subtitle-1">
        Justificar Asistencia
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid">

          <v-alert
            v-if="modalJustificacion"
            type="info"
            dense
            outlined
            class="mb-4"
            color="blue"
            icon="mdi-information"
          >
            Este alumno ya cuenta con una justificación. No se permite subir otra.
          </v-alert>

          <!-- Fecha -->
          <v-text-field
          v-if="modalJustificacion"
          :value="formatearFecha(modalJustificacion.fecha)"
          label="Fecha de justificación"
          outlined
          readonly
          class="mb-4 grey lighten-4"
          prepend-icon="mdi-calendar"
          ></v-text-field>

          <!-- Motivo -->
          <v-textarea
            v-model="motivo"
            label="Motivo"
            rows="3"
            outlined
            required
            :readonly="!!modalJustificacion"
            :rules="[v => !!v || 'Motivo es obligatorio']"
            class="mb-4"
            :class="{ 'grey lighten-4': modalJustificacion }"
          ></v-textarea>

          <!-- Input archivos -->
          <v-file-input
            v-if="!modalJustificacion"
            v-model="archivos"
            label="Selecciona archivos PDF o imágenes"
            multiple
            show-size
            accept=".pdf, image/*"
            outlined
            :rules="[v => previews.length > 0 || 'Debes subir al menos un archivo']"
            :hint="'Tamaño máximo por archivo: 1.20 MB'"
            persistent-hint
            @change="procesarArchivos"
          ></v-file-input>

          <!-- Botón eliminar todos -->
          <v-btn
            v-if="previews.length && !modalJustificacion"
            color="red"
            class="mb-4"
            @click="eliminarTodos"
          >
            Eliminar Todos
          </v-btn>

          <!-- Preview de archivos -->
          <v-row v-if="previews.length" class="mt-4" dense>
            <v-col
              v-for="(archivo, index) in previews"
              :key="index"
              cols="12"
              md="4"
            >
              <v-card class="pa-2" outlined>
                <div v-if="archivo.tipo === 'imagen'" style="position: relative;">
                  <v-img
                    :src="archivo.url"
                    height="200px"
                    contain
                    @click="abrirZoom(archivo)"
                    class="pointer"
                  ></v-img>
                  <v-btn
                    v-if="!modalJustificacion"
                    icon
                    small
                    color="red"
                    style="position: absolute; top:5px; right:5px;"
                    @click="eliminarArchivo(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>

                <div v-else-if="archivo.tipo === 'pdf'" style="position: relative;">
                  <v-card-text class="text-center">
                    <v-icon large>mdi-file-pdf</v-icon>
                    <p>{{ archivo.nombre }}</p>
                    <v-btn
                      text
                      color="primary"
                      @click="abrirZoom(archivo)"
                    >Ver PDF</v-btn>
                  </v-card-text>
                  <v-btn
                    v-if="!modalJustificacion"
                    icon
                    small
                    color="red"
                    style="position: absolute; top:5px; right:5px;"
                    @click="eliminarArchivo(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!modalJustificacion" text @click="closeDialog">Cancelar</v-btn>
        <v-btn v-if="!modalJustificacion" color="primary" :disabled="!formValid" @click="submitForm">Guardar</v-btn>
        <v-btn v-if="modalJustificacion" text color="primary" @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog zoom -->
    <v-dialog v-model="zoomDialog" max-width="90%" max-height="90%">
      <v-card v-if="archivoZoom">
        <v-card-text class="pa-0" style="height:80vh;">
          <v-img
            v-if="archivoZoom.tipo === 'imagen'"
            :src="archivoZoom.url"
            contain
            style="height:100%; width:100%;"
          ></v-img>

          <iframe
            v-else-if="archivoZoom.tipo === 'pdf'"
            :src="archivoZoom.url"
            style="width:100%; height:100%; border:none;"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="zoomDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Alertas y carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-dialog>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue';
import carga  from '@/components/alertas/carga.vue';

export default {
  components: {
    carga,
    Alerta
  },
  props: [
    'modalJustificarAsistencia',
    'modalJustificacion',
    'modalId_usuario',
    'modalEscuela',
    'modalIderp',
    'modalFecha',
    'modalSesion',
    'modalIdgrupo'
  ],
  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    loader: true,
    cargar: false,
    motivo: '',
    archivos: [],
    previews: [],
    formValid: false,
    zoomDialog: false,
    archivoZoom: null,
  }),

  watch: {
    'modalJustificarAsistencia.status'(valor) {
      if (valor) {

        if( this.modalJustificacion ) {

          this.motivo =  this.modalJustificacion.motivo

          // Procesar evidencias recuperadas desde el backend
          this.previews = this.modalJustificacion.evidencias.map((evidencia, index) => {
            const base64 = evidencia.base64 || '';
            const isDataUrl = base64.startsWith('data:');
            const isImage = base64.startsWith('data:image') || /^(\/9j|iVBOR|R0lGOD|UklGR)/.test(base64);
            const isPdf = base64.startsWith('data:application/pdf') || base64.startsWith('JVBER');
            const url = isDataUrl
              ? base64
              : `data:${isPdf ? 'application/pdf' : 'image/png'};base64,${base64}`;

            return {
              file: null, // Ya no hay archivo File, pero lo dejamos por compatibilidad
              nombre: `archivo_${index + 1}.${isImage ? 'png' : isPdf ? 'pdf' : 'bin'}`,
              tipo: isImage ? 'imagen' : isPdf ? 'pdf' : 'otro',
              url
            };
          });

        } else {
          this.resetForm();
        }

      }
    }
  },

  methods: {
    closeDialog() {
      this.modalJustificarAsistencia.status = false;
      this.$emit('modal-cerrado');
      this.resetForm();
    },

    resetForm() {
      this.motivo = '';
      this.archivos = [];
      this.previews.forEach(archivo => URL.revokeObjectURL(archivo.url));
      this.previews = [];
      this.formValid = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },

    procesarArchivos(event) {
    const MAX_SIZE = 1.2 * 1024 * 1024; // 1.20 MB en bytes

    const archivos = Array.from(event || []);

    // Archivos que exceden el tamaño
    const archivosGrandes = archivos.filter(file => file.size > MAX_SIZE);

    if (archivosGrandes.length) {
      const nombres = archivosGrandes.map(f => f.name).join(', ');
      this.$notify({
        group: 'foo',
        title: 'Archivo demasiado pesado',
        text: `Los siguientes archivos superan los 1.20 MB: ${nombres}. 
Por favor reduce su tamaño (comprimir PDF o bajar resolución de la imagen) antes de subirlos.`,
        type: 'warn',
        duration: 8000
      });
    }

    // Solo procesar archivos que NO exceden el tamaño
    const nuevosPreviews = archivos
      .filter(file => file.size <= MAX_SIZE)
      .filter(file => !this.previews.some(p => p.nombre === file.name)) // filtra duplicados
      .map(file => {
        const tipo = file.type.includes('pdf') ? 'pdf' : 'imagen';
        return {
          file,
          nombre: file.name,
          tipo,
          url: URL.createObjectURL(file),
        };
      });

    if (nuevosPreviews.length === 0 && archivos.length > 0 && !archivosGrandes.length) {
      // Caso solo duplicados (mantienes tu mensaje actual)
      this.$notify({
        group: 'foo',
        title: 'Archivo duplicado o con el mismo nombre',
        text: 'No se pueden agregar archivos duplicados o con el mismo nombre',
        type: 'warn',
        duration: 5000
      });
    }

    this.previews = [...this.previews, ...nuevosPreviews];
    this.archivos = [];
  },

    abrirZoom(archivo) {
      this.archivoZoom = archivo;
      this.zoomDialog = true;
    },

    eliminarArchivo(index) {
      URL.revokeObjectURL(this.previews[index].url);
      this.previews.splice(index, 1);
    },

    eliminarTodos() {
      this.previews.forEach((archivo) => URL.revokeObjectURL(archivo.url));
      this.previews = [];
    },

    formatearFecha(fechaRaw) {
      if (!fechaRaw) return '';
      const fecha = new Date(fechaRaw);
      return fecha.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    async submitForm() {
  if (!this.formValid) return;
  this.cargar = true;

  const formData = new FormData();

  formData.append('motivo', this.motivo);
  formData.append('iderp', this.modalIderp);
  formData.append('id_grupo', this.modalIdgrupo);
  formData.append('id_usuario', this.modalId_usuario);
  formData.append('sesion', this.modalSesion);
  formData.append('escuela', this.modalEscuela);
  formData.append('fecha', this.modalFecha);

  // ✔️ Agregar archivos directamente
  this.previews.forEach(item => {
    formData.append("evidencias", item.file);
  });

  try {
    await this.$http.post('/alumnos.add.justificacion', formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    this.parametros = { dialogError: true, mensaje: 'Justificación guardada correctamente', color: 'success' };
    this.respuestaAlerta = true;
    this.cargar = false;
    this.closeDialog();

  } catch (err) {
    console.log(err);
    const mensaje = err && err.response && err.response.data && err.response.data.message
      ? err.response.data.message
      : 'No se pudo guardar la justificación';
    this.parametros = { dialogError: true, mensaje, color: 'error' };
    this.respuestaAlerta = true;
    this.cargar = false;
  }
},
    /*async submitForm() {
      if (!this.formValid) return;
      this.cargar = true;

      // Convertimos todos los archivos a base64
      const evidenciasBase64 = await Promise.all(
        this.previews.map(async (archivo) => {
          const base64 = await this.archivoABase64(archivo.file);
          return { base64 };
        })
      );

      const formData = new FormData();
      formData.append('motivo', this.motivo);
      formData.append('iderp', this.modalIderp);
      formData.append('id_grupo', this.modalIdgrupo);
      formData.append('id_usuario', this.modalId_usuario);
      formData.append('sesion', this.modalSesion);
      formData.append('escuela', this.modalEscuela);
      formData.append('fecha', this.modalFecha);

      // Agregamos las evidencias como string JSON
      formData.append('evidencias', JSON.stringify(evidenciasBase64));

      this.$http.post('/alumnos.add.justificacion', formData)
      .then(res => {
        this.parametros = { dialogError: true, mensaje: 'Justificación guardada correctamente', color: 'success' };
        this.respuestaAlerta = true;
        this.cargar = false;
        this.closeDialog();
      })
      .catch(err => {
        console.log( err )
        this.respuestaAlerta = true;
        this.cargar = false;
      });
    },

    archivoABase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = err => reject(err);
        reader.readAsDataURL(file); // Esto lo convierte a base64
      });
    }*/

  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
